import { css, jsx } from '@emotion/core';
import { Icon, Tooltip } from 'antd';
import React from 'react';

import { colors } from '@/styles';

const styles = {
  labelContainer: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  `,
  label: css`
    color: ${colors.secondaryGray};
    font-weight: 900;
    margin-bottom: 1.2rem;
  `,
  labelRequired: css`
    color: ${colors.primaryBlue};
    margin: 0 0 0 2px;
  `,
  toolTip: css`
    margin-bottom: 1.2rem;
    align-self: center;
    font-size: 1.6rem;
    color: ${colors.secondaryBlue};
  `,
};

const Label = ({ info }) => {
  const { label, required, extraInfo } = info;
  return (
    <div css={styles.labelContainer}>
      <div style={{ display: 'flex' }}>
        <p css={styles.label}>{label}</p>
        {required ? <span css={styles.labelRequired}> *</span> : null}
      </div>
      {extraInfo ? (
        <Tooltip title={extraInfo}>
          <Icon
            theme="filled"
            twoToneColor={colors.primaryBlue}
            type="info-circle"
            css={styles.toolTip}
          />
        </Tooltip>
      ) : null}
    </div>
  );
};

export default Label;
